export enum EnvironmentType {
  Development = 'development',
  Stage = 'stage',
  Production = 'production',
  Local = 'local',
}
